import { render, staticRenderFns } from "./customerBalance.vue?vue&type=template&id=78021cc6"
import script from "./customerBalance.vue?vue&type=script&lang=js"
export * from "./customerBalance.vue?vue&type=script&lang=js"
import style0 from "./customerBalance.vue?vue&type=style&index=0&id=78021cc6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports